import * as React from 'react';
import { Link } from 'react-router-dom';
import { Product, Category, Variant } from '../product';

export interface ProductListItemProps {
  product: Product;
  index: number;
}

const indicatorClasses = (active: boolean) => {
  return `db w1 h1 br-100 bg-${active ? 'green' : 'red'}`;
};

export function ProductListItem(props: ProductListItemProps) {
  return (
    <div
      className={`flex justify-stretch items-center pv2 pv3-ns ${
        props.index > 0 ? 'bt b--black-10' : ''
      }`}
    >
      <div className="mr4">
        <div className={indicatorClasses(props.product.available)} />
      </div>
      <div className="mr4">
        <img className="w3 h3 db br3" src={props.product.image_url} />
      </div>
      <div className="w-20">
        <h4 className="lh-title ma0 mb2">{props.product.name}</h4>
        <p className="lh-copy ma0 f6 black-50 truncate">
          {props.product.description_text}
        </p>
      </div>
      <div className="pl3 pl4-ns w-20">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Categories</h4>
        {props.product.categories.map((item: Category) => item.name).join(', ')}
      </div>
      <div className="pl3 pl4-ns w-40">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Variants </h4>
        {props.product.variants.map((variant: Variant) => (
          <Link
            to={{
              pathname: `/products/${variant.product_id}/variants/${variant.id}`,
              state: {
                variant,
              },
            }}
            className="pa2 bg-black dib mr2 mb2 br4 pl3 bg-near-white hover-bg-black-10 black link"
          >
            {variant.name}{' '}
            <small
              className={`dib pa0 b ph2 br4 ml2 ${
                variant.in_stock ? 'green' : 'red'
              }`}
            >
              {variant.in_stock ? 'IN STOCK' : 'OUT OF STOCK'}{' '}
              {variant.stock_count > 0 &&
                `(
              ${variant.stock_count})`}
            </small>
          </Link>
        ))}
        <Link
          to={{
            pathname: `/products/${props.product.id}/variants/new`,
            state: {
              product: props.product,
            },
          }}
          className="pa2 bg-black dib mr2 mb2 br4 ph3 bg-near-white hover-bg-black-10 black b link"
        >
          Add new
        </Link>
      </div>
      <div className="tc ml3">
        <Link
          to={{
            pathname: `/products/${props.product.id}/variants`,
            state: {
              product: props.product,
            },
          }}
          className="link black underline dim b"
        >
          Variants
        </Link>
      </div>
      <div className="tc ml4">
        <Link
          to={{
            pathname: `/products/${props.product.id}`,
            state: {
              product: props.product,
            },
          }}
          className="link black underline b dim"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
